//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
export default {
  name: 'SiteWeatherModal',
  mixins: [ModalFormMixin, GetSiteIdMixin],
  data: function data() {
    return {
      title: '站点天气表单',
      tableName: 'om_site_weather',
      form_fields: ['siteId', 'weather', 'temperature', 'humidity', 'windForce', 'windDirection', 'tenantId'],
      form_fields_time: ['time'],
      validatorRules: {
        siteId: {
          rules: [{
            required: true,
            message: '请输入站点!'
          }]
        }
      }
    };
  },
  props: ['pagePath'],
  watch: {
    currentSiteId: function currentSiteId(value) {
      this.siteId = value;
    }
  },
  created: function created() {},
  methods: {
    add: function add(siteId) {
      console.log('record', siteId);
      if (undefined == siteId) this.$message.warning('请选择单个站点');
      this.edit({
        siteId: siteId
      });
    }
  }
};